import { createContext, useContext } from 'react';

import type { CustomizationView } from '@api-client/products';

type PAPIProductBase = {
    id: string;
    localizedName: string;
    type: string;
    _embedded: { customization: CustomizationView };
};

const ActivePAPIProductContext = createContext<PAPIProductBase>({} as PAPIProductBase);

export const ActivePAPIProductProvider = ActivePAPIProductContext.Provider;

export const useActivePAPIProduct = <Product extends PAPIProductBase>() => {
    const product = useContext(ActivePAPIProductContext);

    if (Object.keys(product).length === 0) {
        throw new Error('useActivePAPIProduct must be used within the ActivePAPIProductProvider');
    }

    return product as Product;
};

export const useUnsafeActivePAPIProduct = <Product extends PAPIProductBase>(): Partial<Product> => {
    const product = useContext(ActivePAPIProductContext);

    return product as Product;
};
